import { Component, OnInit } from '@angular/core';
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import { Subscription } from 'rxjs';
import { VideoService } from 'src/app/services/video/video.service';
declare var $: any;


@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {
  videoList: any[] = [];
  sub: Subscription[] = [];
  constructor(private service: VideoService) {}

  ngOnInit(): void {
    this.service.getTitleWiseVideoList('Video Gallery');
    this.sub[0] = this.service.titleWiseVideoChange.subscribe((data) => {
      if (data && data.length > 0) {
        this.videoList = data;
      } else {
        this.videoList = [];
      }
    });

    setTimeout(() => {
      this.initializeLightGallery();
    }, 1500);
  }

  initializeLightGallery() {
    $('.gallery-container').each(function (index) {
      lightGallery(this, {
        speed: 500,
        plugins: [lgVideo],
      });
    });
  }

  getYouTubeVideoId(url: string): string | null {
    const videoMatch = url.match(
      /(?:v=|\/embed\/|\/watch\?v=|youtu\.be\/|\/shorts\/|\/v\/)([^&?/]+)/
    );
    return videoMatch ? videoMatch[1] : null;
  }
}
